import { ApolloClient, InMemoryCache, gql } from "@apollo/client";
import { getOrganisationDetails, getOrganisationId } from "../organisations/organisationsSlice";
import StorageService from "../../util/storage";

const client = new ApolloClient({
  uri: `${process.env.REACT_APP_BACKEND_URL}/graphql`,
  cache: new InMemoryCache(),
  headers: {
    Authorization: `${StorageService.getItem("bearer")}`,
  },
});

export const fetchShiftbats = async (userId) => {
  const org = await getOrganisationDetails();

  console.log("fetchShiftbats", org);

  const shiftbats = [];

  const promises = [];
  const shiftbatPromises = [];

  org.Regions?.forEach((region) => {
    promises.push(fetch(`${process.env.REACT_APP_SHIFTBATS_URL}/driverable/shifts?_k=${region.region_id}`));
  });

  await Promise.all(promises).then((responses) => {
    responses.forEach((response) => {
      if (!response.ok) {
        throw new Error(`Failed to fetch driver duties for ${org.organisationId}`);
      }
      shiftbatPromises.push(response.json());
    });
  });

  await Promise.all(shiftbatPromises).then((shiftbatResponses) => {
    shiftbatResponses.forEach((shiftbatResponse, i) => {
      const region = org.Regions[i];
      shiftbatResponse.forEach((shiftbat) => {
        if (shiftbat.published)
          shiftbats.push({
            ...shiftbat,
            region: region,
          });
      });
    });
  });

  return shiftbats;

  // const query = gql`
  //     query getShiftbats($id: String) {
  //         shiftbats(filters: { organisation: { orgId: { eq: $id } } }) {
  //             data {
  //                 id
  //                 attributes {
  //                     shiftbats {
  //                         name
  //                         file {
  //                             data {
  //                                 attributes {
  //                                     url
  //                                 }
  //                             }
  //                         }
  //                         categories {
  //                             data {
  //                                 attributes {
  //                                     name
  //                                 }
  //                             }
  //                         }
  //                     }
  //                 }
  //             }
  //         }
  //     }
  // `;
  // const { data } = await client.query({
  //     query,
  //     variables: { id: orgId },
  // });
  // return data.shiftbats.data;
};
